import type { Point } from "@pdfking/math"

/** Whether `p` lies within the polygon `points` (even–odd). */
export const InsidePolygon = <T extends number>(points: Point<T>[], { x, y }: Point<T>): boolean =>
  points.reduce((inside, a, i) => {
    const b = points[(i + points.length - 1) % points.length]!
    const crosses = a.y > y !== b.y > y && x < a.x + ((b.x - a.x) * (y - a.y)) / (b.y - a.y)
    return crosses ? !inside : inside
  }, false)
